<template>

    <SidebarComponent>

      <ReplyOrForwardComponent/>

    </SidebarComponent>

</template>

<script>
import SidebarComponent from "../components/SidebarComponent.vue";
import ReplyOrForwardComponent from "../components/ReplyOrForwardComponent.vue";

export default {
  name: "ReplyOrForwardPage.vue",
  components: {
    SidebarComponent,
    ReplyOrForwardComponent
  },
}
</script>
